import { PostalAddressDto } from "Store/interfaces/PostalAddressDto";

export interface CompanyTransferSpecifications {
  readonly insuranceShouldBeTransferredFromAnotherCompany?: boolean;
  readonly companyToTransferInsuranceFrom?: CompanyInfo;
  readonly companyChangeReason?: CompanyChangeReason | null;
}
const COMPANY_CHANGE_REASONS = [
  "DEFAULT",
  "RENEWAL",
  "RIGHT_OF_WITHDRAWAL",
  "TAKEOVER_INSURANCE_FROM_INTENDED_COMPANY",
] as const;

export type CompanyChangeReason = (typeof COMPANY_CHANGE_REASONS)[number];

export interface CompanyInfo {
  readonly name?: string;
  readonly organization?: any;
  readonly emails?: any[] | any;
  readonly address?: PostalAddressDto;
  readonly companyType?: CompanyType;
}

export enum CompanyType {
  OLD_INSURANCE,
  BANK,
  BONUS_INSURANCE,
  LEASING,
}

export enum BonusTransfer {
  MY_OWN = "MY_OWN",
  UNKNOWN = "UNKNOWN",
  NONE = "NONE",
}
